import { Container } from "./styles";
import ScrollAnimation from "react-animate-on-scroll";

export function About() {
  return (
    <Container id="about">
      <div className="about-text">
        <ScrollAnimation animateIn="fadeInLeft">
          <h2>About Me</h2>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInLeft" delay={0.1 * 1000}>
          <p>
            Hello! I'm <strong>Abhay Prajapati</strong>, Founder & CEO of
            <strong> NeXOffers Media & Technologies</strong>—a full-service
            AdTech, Digital Marketing, and Technology company dedicated to
            helping businesses accelerate growth through innovative marketing,
            technology, and data-driven strategies. I believe every business,
            regardless of its size, deserves access to world-class digital
            solutions that drive measurable results.
          </p>
        </ScrollAnimation>

        <ScrollAnimation
          animateIn="fadeInLeft"
          delay={0.2 * 1000}
          style={{ marginTop: "2rem", marginBottom: "2rem" }}
        >
          <p>
            At NeXOffers, we partner with startups, SMEs, and enterprise brands
            to build scalable digital ecosystems. From performance marketing,
            affiliate marketing, branding, SEO, and social media marketing to
            web development, AI-powered automation, analytics, and custom
            software solutions, our mission is to transform ideas into
            high-impact digital experiences that generate sustainable business
            growth.
          </p>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInLeft" delay={0.3 * 1000}>
          <p>
            My expertise spans digital strategy, performance marketing, product
            development, growth consulting, media buying, search engine
            optimization, and business automation. I am passionate about
            leveraging technology and creativity to solve real-world business
            challenges, helping brands build stronger customer relationships,
            increase revenue, and stay ahead in an ever-evolving digital
            landscape.
          </p>
        </ScrollAnimation>

        <ScrollAnimation
          animateIn="fadeInLeft"
          delay={0.4 * 1000}
          style={{ marginTop: "2rem" }}
        >
          <p>
            Today, NeXOffers Media & Technologies continues to expand its
            capabilities across AdTech, AI, Software Development, Digital
            Advertising, Creative Services, and Growth Marketing. My vision is
            to build one of the most trusted technology-driven marketing
            companies that empowers businesses globally with innovation,
            transparency, and measurable success.
          </p>
        </ScrollAnimation>

      </div>
    </Container>
  );
}
